export default {
    isAuthenticated(state, getters) {

        
        if (!state.cliente) {
            return false;
        }
        const {  codigo } = state.cliente;
        
        if (!codigo) {
            return false;
        }

        return true;
    },
    vinculos({ relacoes = []}, getters) {        
        let vinculos = relacoes.map(({ sistema }) => sistema);
        vinculos = [...new Set(vinculos)];
        let titulos = {
            'C': 'Condomínio',
            'A': 'Aluguel'
        };
        vinculos = vinculos.map(codigo => ({ codigo, titulo: titulos[codigo] }));
        return vinculos;
    },
    relacoes({ vinculo_id = '', relacoes = [] }, getters) {
        return relacoes.filter(relacao => relacao.sistema == vinculo_id);
    },
    relacao(state, getters) {
        let relacao_id = +state.relacao_id;
        const relacoes = getters.relacoes || [];
        if ('undefined' === typeof relacoes[relacao_id]) {
            relacao_id = 0;
        }
        
        const relacao = relacoes[relacao_id];

        return relacao;
    },
    condominios(state, getters) {
        const relacao = getters.relacao;
        if (!relacao || !relacao.condominios) {
            return [];
        }
        const condominios = relacao.condominios || [];
        return condominios;
    },
    condominio(state, getters) {
        const condominio_id = +state.condominio_id;
        const condominios = getters.condominios || [];
        const condominio = condominios[condominio_id];
        return condominio;
    },
    contratos(state, getters) {
        const relacao = getters.relacao;
        if (!relacao || !relacao.contratos) {
            return [];
        }
        const contratos = relacao.contratos || [];
        return contratos;
    },
    contrato(state, getters) {
        const contrato_id = +state.contrato_id;
        const contratos = getters.contratos || [];
        const contrato = contratos[contrato_id];
        return contrato;
    },
    imoveis(state, getters) {
        const relacao = getters.relacao;
        if (!relacao || !relacao.imoveis) {
            
            return [];
        }
        const imoveis = relacao.imoveis || [];

        
        return imoveis;
    },
    imovel(state, getters) {
        const imovel_id = +state.imovel_id;
        const imoveis = getters.imoveis || [];
        const imovel = imoveis[imovel_id];
        if (!imovel && getters.contrato) {
            return getters.contrato.imovel;
        }
        return imovel;
    },
    controleAcesso(state, getters) {
        let controleAcesso = {};
        if (!getters.relacao) {
            return {}
        }
        let sistema = getters.relacao.sistema;
        
        if (sistema == 'C' && getters.condominio && getters.condominio.controleAcesso) {
            controleAcesso = getters.condominio.controleAcesso;
        }
        if (sistema == 'A' && getters.relacao && getters.relacao.controleAcesso) {
            controleAcesso = getters.relacao.controleAcesso;
        }
        
        
        
        if (0 == Object.keys(controleAcesso).length) {
            return null;
        }
        Object.keys(controleAcesso).forEach(key => {
            Object.keys(controleAcesso[key]).forEach(key2 => {
                controleAcesso[key][key2] = controleAcesso[key][key2] == 'S' || controleAcesso[key][key2]===true;
            });
        });

        controleAcesso.acessoRapido = { acesso: false };
        controleAcesso.mural = { acesso: false };
        controleAcesso.financeiro = { acesso: false };

        if (controleAcesso.segundaVia && controleAcesso.segundaVia.acesso) {
            controleAcesso.acessoRapido.acesso = true;
            controleAcesso.financeiro.acesso = true;
        }
        if (controleAcesso.informeRendimento && controleAcesso.informeRendimento.acesso) {
            controleAcesso.financeiro.acesso = true;
        }

        

        if (sistema == 'C') {
            ['contaCorrente', 'autorizacaoPagamento', 'demonstrativoFinanceiro', 'assembleia'].forEach(key => {
                if (controleAcesso[key] && controleAcesso[key].acesso) {
                    controleAcesso.acessoRapido.acesso = true;
                }
            });
            ['quadroAviso', 'chamaSindico', 'notificacaoMudanca'].forEach(key => {
                if (controleAcesso[key] && controleAcesso[key].acesso) {
                    controleAcesso.mural.acesso = true;
                }
            });
            ['lancamentoLeituraAgua', 'lancamentoLeituraGas', 'contaCorrente', 'relatorioDevedor', 'relatorioDOCs', 'autorizacaoPagamento', 'livroDigital', 'historicoJuridico', 'vencimentoAGO', 'relatorioDOCs'].forEach(key => {
                if (controleAcesso[key] && controleAcesso[key].acesso) {
                    controleAcesso.financeiro.acesso = true;
                }
            });
        } else {
            controleAcesso.financeiro.acesso = true//verificar quando vierem as permissões de aluguel
        }

        return controleAcesso;
    }
};